import React, { Component } from 'react';

import UserService from '../../services/user.service';

const canUseDOM = !!(
  (typeof window !== 'undefined' &&
    window.document && window.document.createElement)
);

export default class Tawk extends Component {
  static displayName = 'Crisp';

  constructor(props) {
    super(props);
    if (!window.$crisp) {
      window.$crisp = [];
    }
    const {
      appID,
    } = props;
    if (!appID || !canUseDOM) {
      return;
    }

    const { $crisp } = window;

    window.CRISP_WEBSITE_ID = appID;
    const that = this;

    if (!$crisp.is) {
      (function(){
        const d = document;
        const s = d.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = 1;
        s.charset = 'UTF-8';
        s.setAttribute('crossorigin', '*');
        s.onload = function() {
          window.$crisp.push(['do', 'chat:show']);
          that.updateUser(props);
        };
        d.head.appendChild(s);
      })();
    }

    this.updateUser(props);
  }

  updateUser(props) {
    const { $crisp } = window;
    if ($crisp && $crisp.is) {
      console.log('props.user!!!!!!!!!!!!!!!!!!!!!!!', props.user)
      if (props.user) {
        setTimeout(function () {
          $crisp.push(['set', 'user:email', [props.user.email]]);
          $crisp.push(['set', 'user:nickname', [props.user.first_name + ' ' + props.user.last_name]]);
          $crisp.push(['set', 'user:avatar', [UserService.getAvatar(props.user)]]);
        }, 1000);
        $crisp.push(['do', 'chat:show']);

      } else {
        $crisp.push(['do', 'session:reset', [false]]);
      }
    }
  }

  shouldComponentUpdate() {
    this.updateUser(this.props)
    return false;
  }

  componentWillUnmount() {
    if (!canUseDOM || !window.$crisp || !window.$crisp.is) return false;
    this.updateUser(this.props)
    window.$crisp.push(['do', 'chat:hide']);
    window.$crisp.push(['do', 'chat:close']);
  }

  render() {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/crisp/Crisp.js